import { Link } from "react-router-dom";

export function Brand({ to = "/", className = "", size = "text-[20px]" }) {
    return (
        <Link
            to={to}
            data-testid="brand-logo"
            className={`inline-flex items-baseline gap-2 font-display font-bold tracking-[-0.01em] text-ink ${size} ${className}`}
        >
            <span className="inline-block h-2.5 w-2.5 rounded-full bg-terracotta translate-y-[-1px]" />
            MYAVEREN
        </Link>
    );
}
